import React from "react";
import { AwesomeButton } from "react-awesome-button";
import { DownloadIcon } from "@primer/octicons-react";  
import 'react-awesome-button/dist/styles.css';
import './style.css';

export default function Sobre() {
    return (
        <section className='Sobre' id='Sobre'>
            <h2 className='titulo-section'>Sobre</h2>
            <article className='conteudo-sobre'>
                <div className="emote-sobre">
                    <img className="gif" src='/assets/gif.gif' />
                </div>
                <div className='texto-sobre'>
                    <p>Meu nome é Pedro Lisboa, sou desenvolvedor front-end, e atualmente estou cursando o Módulo 4 do Curso Full Stack da Kenzie Academy Brasil.</p>
                    <p>Busco sempre inovações em métodos e tecnologias para aperfeiçoamento profissional.</p><p>Atualmente busco a minha primeira oportunidade profissional na área tech para ampliar os conhecimentos.</p>
                    <div className="button-cv">
                        <a href="CvPedroDevFullStack.pdf" target="_blank">
                            <AwesomeButton type="primary" ref={null} after={<DownloadIcon />}>Currículo</AwesomeButton>
                        </a>
                    </div>
                </div>
            </article>
        </section>
    )
}